import { createTheme } from "@mui/material/styles";

import { BACKGROUND, PRIMARY, SECONDARY } from "../colors";

export const theme = createTheme({
  palette: {
    primary: {
      main: PRIMARY.main,
      light: PRIMARY.light,
      dark: PRIMARY.dark
    },
    secondary: {
      main: SECONDARY.main,
      light: SECONDARY.light,
      dark: SECONDARY.dark
    },
    background: {
      default: BACKGROUND.default,
      paper: BACKGROUND.paper
    }
  },
  typography: {
    fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", Arial, sans-serif",
    fontSize: 13
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", Arial, sans-serif"
        }
      }
    }
  }
});
